import React from 'react';
import { observer } from 'mobx-react-lite';
import { useFullFormPageStore } from 'store/pages/quote/add-employees/full-form/pageStore';
import { DynamicFormModal } from '@insurancemenu/imenu-components-lib';
import { toJS, action } from 'mobx';
import { DependentsChoice, ProductLineInterestChange } from 'types/electionService';

import SubscriberInterestCard from 'components/common/election/cards/SubscriberInterestCard';
import { PRODUCT_LINE_RATE_MODAL_TEST_ID, ELECTIONS_TAB_TEST_ID } from '../../constants';

const ElectionsTab: React.FC = observer(() => {
  const { electionsModule, electionsCardPresenter, subscriberBasicInfo, openProductLineRateForm } =
    useFullFormPageStore();

  const subscriberElectionsDelegate = electionsModule.subscribers[0];
  if (!subscriberElectionsDelegate || !subscriberBasicInfo) {
    throw new Error('Cannot render ElectionsTab without elections and basic-info');
  }

  const pLineRateModalDelegate = electionsModule.productLineRateModalDelegate;

  const domainProductLineIds = electionsModule.domainProductLineIds.map((productLineId) => toJS(productLineId));
  const requiredSubInfo = toJS(electionsModule.electionPresenter) ?? undefined;

  const onProductLineInterestChange = action((change: ProductLineInterestChange): void => {
    void subscriberElectionsDelegate.syncProductLineInterest(change);
  });

  const onDependentsChange = action((dependentsChoice: DependentsChoice): void => {
    void subscriberElectionsDelegate.syncDependentsInInterestedProductLines(dependentsChoice);
  });

  const onProductLineAction = action((formId: string): void => {
    void openProductLineRateForm(formId);
  });

  return (
    <div data-test-id={ELECTIONS_TAB_TEST_ID}>
      <SubscriberInterestCard
        subscriber={electionsCardPresenter}
        productLineIds={domainProductLineIds}
        requiredSubInfo={requiredSubInfo}
        callbacksMap={{
          onDependentsChange,
          onProductLineAction,
          onProductLineInterestChange,
        }}
      />
      <DynamicFormModal
        show={pLineRateModalDelegate.isVisible}
        onClose={pLineRateModalDelegate.close}
        formDelegate={pLineRateModalDelegate.dynamicFormDelegate}
        isEditable
        modalMaxWidth="90rem"
        formBodyMinHeight="20rem"
        data-test-id={PRODUCT_LINE_RATE_MODAL_TEST_ID}
      />
    </div>
  );
});

export default ElectionsTab;
